import { FormatDate } from './formatDate';

/** True when a scalar field should be shown on the public machine page. */
export const hasDisplayValue = (value) => {
    if (value === null || value === undefined) {
        return false;
    }
    if (typeof value === 'string') {
        return value.trim().length > 0;
    }
    if (typeof value === 'number') {
        return !Number.isNaN(value);
    }
    return Boolean(value);
};

/** True when rich HTML (Quill) has visible text content. */
export const hasRichTextContent = (html) => {
    if (!html || typeof html !== 'string') {
        return false;
    }
    const text = html.replace(/<[^>]*>/g, '').replace(/&nbsp;/gi, ' ').trim();
    return text.length > 0;
};

export const hasFormattedDate = (date) => hasDisplayValue(FormatDate(date));

export const getMachineDimensionsLabel = (machine) => {
    const { length, width, height } = machine || {};
    if (!hasDisplayValue(length) || !hasDisplayValue(width) || !hasDisplayValue(height)) {
        return null;
    }
    return `${length} X ${width} X ${height}`;
};

const buildContactFields = (contact, labels) => [
    { label: labels.contact, value: contact?.name },
    { label: labels.phone, value: contact?.phone_number },
    { label: labels.email, value: contact?.email },
    { label: labels.post, value: contact?.post },
].filter((field) => hasDisplayValue(field.value));

/** Rows and contacts to display for the public maintenance (contract) block. */
export const getPublicMaintenanceDisplay = (contract_machine, labels) => {
    const contract = contract_machine?.[0]?.contract_date?.contract;
    if (!contract) {
        return { rows: [], contacts: [] };
    }

    const rows = [
        { label: labels.company, value: contract.company?.name },
        { label: labels.startDate, value: FormatDate(contract.firstPeriodStartDate) },
        { label: labels.endDate, value: FormatDate(contract.lastPeriodEndDate) },
    ].filter((row) => hasDisplayValue(row.value));

    const contacts = (contract.company?.company_contact || [])
        .map((contact) => buildContactFields(contact, labels))
        .filter((fields) => fields.length > 0);

    return { rows, contacts };
};

export const hasPublicMaintenanceContent = (contract_machine, labels) => {
    const { rows, contacts } = getPublicMaintenanceDisplay(contract_machine, labels);
    return rows.length > 0 || contacts.length > 0;
};
